import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { preferencesAccountSchema } from '../schemas/preferences-account.schema';

const requestSchema = preferencesAccountSchema.pick({
  shortRestLocationId: true,
  longRestLocationId: true,
  preferredFuelLocations: true,
});

/**
 * Defines the preferences for the account
 * @param preferences The preferences for the account
 * @returns Data object containing the newly assigned Preferences
 */
export function postPreferencesAccount(
  this: unknown,
  preferences: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).preferencesAccountUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(preferences),
      })
    )
  ).pipe(selectData(preferencesAccountSchema));
}
